// extracted by mini-css-extract-plugin
export default {"subtitle":"tD_UxI"};